import { post as postAPICall } from 'aws-amplify/api';
import { errorHandler } from 'utils/Api';

export const createWarehouseClient = async (poBoxData) => {
    try {
        const postPayload = {
            apiName: "unboxing",
            path: "/createWarehouseClient",
            options: {
                body: poBoxData
            }

        };
        const restOperation = await postAPICall(postPayload).response;
        const response = await restOperation.body.json();

        if (response.data != "success") {
            errorHandler(postPayload, `Error al crear el cloente en el warehouse`);
        }
    } catch (err) {
        errorHandler(poBoxData, `Error al crear el cloente en el warehouse`);
    }
}